export const isAfterToday = (date: Date) => date > new Date();

export const isDateDisabledWhenDateFrom =
  (dateFrom: Date) =>
  (date: Date): boolean =>
    date < dateFrom || isAfterToday(date);

export const isDateDisabledWhenDateTo =
  (dateTo: Date) =>
  (date: Date): boolean =>
    date > dateTo || isAfterToday(date);
